const routes = [
    {
        path: '',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                path: '/usuarios_logs',
                redirect: '/usuarios_logs/index',
            },
            {
                path: '/usuarios_logs/index',
                component: () => import('../views/Listar')
            }
        ]
    }
]
export default routes
